<app-header title="self-serve.payYourTeam.myProfile"></app-header>

<form
    [appFormPersistence]="!stepStatus && !isLoading ? 'myProfileForm' : ''"
    [fieldsToExclude]="['address']"
    invalidControlScroll
    #form="ngForm"
    [class.loading]="isLoading"
    (ngSubmit)="onSubmit()"
>
    <app-segment-header title="self-serve.payYourTeam.personalInformation"></app-segment-header>

    <!-- avatar photo -->
    <div *ngIf="!isLoading" class="flex align-items-center margin-bottom-2">
        <app-avatar [employee]="employee" size="large"></app-avatar>
        <ui-button (click)="openAvatarDialog()" type="link" size="no-padding">{{
            (employee.avatarId
                ? 'self-serve.payYourTeam.changeAvatarPhoto'
                : 'self-serve.payYourTeam.uploadAvatarPhoto'
            ) | translate
        }}</ui-button>
    </div>

    <div class="responsive-grid">
        <div class="row">
            <mat-form-field>
                <mat-label>{{ 'self-serve.payYourTeam.firstName' | translate }}</mat-label>
                <input
                    required
                    matInput
                    type="text"
                    name="firstName"
                    #firstName="ngModel"
                    [(ngModel)]="employee.firstName"
                />
                <mat-error *ngIf="firstName.invalid"> {{ 'self-serve.fieldRequired' | translate }} </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'self-serve.payYourTeam.lastName' | translate }}</mat-label>
                <input
                    required
                    matInput
                    type="text"
                    name="lastName"
                    #lastName="ngModel"
                    [(ngModel)]="employee.lastName"
                />
                <mat-error *ngIf="lastName.invalid"> {{ 'self-serve.fieldRequired' | translate }} </mat-error>
            </mat-form-field>
        </div>
        <mat-form-field>
            <mat-label>{{ 'self-serve.payYourTeam.email' | translate }}</mat-label>
            <input required matInput disabled type="text" name="email" #email="ngModel" [(ngModel)]="account.email" />
            <mat-error *ngIf="email.invalid"> {{ 'self-serve.fieldRequired' | translate }} </mat-error>
        </mat-form-field>
        <div class="row">
            <mat-form-field>
                <mat-label>{{ 'self-serve.payYourTeam.legalFirstName' | translate }}</mat-label>
                <input
                    required
                    matInput
                    type="text"
                    name="legalFirstName"
                    #legalFirstName="ngModel"
                    [(ngModel)]="account.legalFirstName"
                />
                <mat-error *ngIf="legalFirstName.invalid"> {{ 'self-serve.fieldRequired' | translate }} </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'self-serve.payYourTeam.legalMiddleName' | translate }}</mat-label>
                <input
                    matInput
                    type="text"
                    name="legalMiddleName"
                    #legalMiddleName="ngModel"
                    [(ngModel)]="account.legalMiddleName"
                />
                <mat-error *ngIf="legalMiddleName.invalid"> {{ 'self-serve.fieldRequired' | translate }} </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'self-serve.payYourTeam.legalLastName' | translate }}</mat-label>
                <input
                    required
                    matInput
                    type="text"
                    name="legalLastName"
                    #legalLastName="ngModel"
                    [(ngModel)]="account.legalLastName"
                />
                <mat-error *ngIf="legalLastName.invalid"> {{ 'self-serve.fieldRequired' | translate }} </mat-error>
            </mat-form-field>
        </div>
        <ui-date-picker
            [label]="'self-serve.payYourTeam.dateOfBirth' | translate"
            [(ngModel)]="employee.bornOn"
            [required]="true"
            #bornOn="ngModel"
            name="bornOn"
            [minDate]="minBornOnDate"
            [maxDate]="maxBornOnDate"
        >
        </ui-date-picker>
        <ui-date-picker
            [label]="'self-serve.payYourTeam.hireDate' | translate"
            [(ngModel)]="employee.hiredAt"
            [required]="true"
            #hiredAt="ngModel"
            name="hiredAt"
        >
        </ui-date-picker>
        <mat-form-field>
            <mat-label>{{ 'self-serve.payYourTeam.sin' | translate }}</mat-label>
            <input
                matInput
                type="text"
                pattern="[0-9]{9,9}"
                placeholder="123456789"
                #sin="ngModel"
                name="sin"
                required
                [(ngModel)]="employee.sin"
            />
            <mat-hint>{{ 'self-serve.payYourTeam.sinHint' | translate }}</mat-hint>
            <mat-error *ngIf="sin.invalid">{{ 'self-serve.payYourTeam.sinInvalid' | translate }}</mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label appRemoveAriaOwns>{{ 'forms.applicant-tracker.hire-flow.position' | translate }}</mat-label>
            <mat-select
                placeholder="{{ 'forms.applicant-tracker.hire-flow.selectAPosition' | translate }}"
                required
                [(ngModel)]="employee.job"
                #position="ngModel"
                [compareWith]="isSameModel"
                name="position"
            >
                <mat-option (click)="showCreateJobModal = true"
                    ><span class="add-option">{{
                        'forms.applicant-tracker.hire-flow.addNewPosition' | translate
                    }}</span></mat-option
                >
                <mat-option *ngFor="let position of jobs" [value]="position">{{ position.title }}</mat-option>
            </mat-select>
            <mat-error *ngIf="position.invalid">{{ position.errors | formErrors }}</mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label appRemoveAriaOwns>{{ 'self-serve.payYourTeam.office' | translate }}</mat-label>
            <mat-select
                required
                name="employeeOffice"
                #employeeOffice="ngModel"
                [(ngModel)]="employee.officeId"
                [placeholder]="'self-serve.payYourTeam.selectAnOption' | translate"
            >
                <mat-option *ngFor="let office of offices" [value]="office.id">{{ office.name }}</mat-option>
            </mat-select>
            <mat-error *ngIf="form.submitted && employeeOffice.invalid">{{
                'self-serve.fieldRequired' | translate
            }}</mat-error>
        </mat-form-field>
        <ui-banner *ngIf="!offices.length" variant="info">
            <div>
                <p>{{ 'self-serve.payYourTeam.addYourOfficePreviousStep' | translate }}</p>
                <p class="margin-top-1">
                    <a [routerLink]="'../company-profile'">{{
                        'self-serve.payYourTeam.addOfficeAddress' | translate
                    }}</a>
                </p>
            </div>
        </ui-banner>
    </div>

    <app-segment-header title="self-serve.address"></app-segment-header>
    <app-address required name="address" [(ngModel)]="employeeAddress" [showAutocomplete]="true"></app-address>

    <app-segment-header title="self-serve.payYourTeam.compensation"></app-segment-header>

    <div class="responsive-grid">
        <mat-form-field>
            <mat-label appRemoveAriaOwns>{{ 'self-serve.payYourTeam.salaryFrequency' | translate }}</mat-label>
            <mat-select name="salaryFrequency" required #salaryFrequency="ngModel" [(ngModel)]="salary.frequency">
                <mat-option *ngFor="let frequency of ['year', 'hour']" [value]="frequency">{{
                    'self-serve.' + frequency | translate
                }}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ salary.frequencyLabel | translate }}</mat-label>
            <input
                type="text"
                matInput
                [ngModel]="salary.rate"
                (ngModelChange)="salary.rate = stripNonNumeric($event); resetCursorPosition()"
                [textMask]="{ mask: currencyMask }"
                [min]="0"
                name="salary"
                #salaryRate="ngModel"
                required
                [placeholder]="
                    'self-serve.payYourTeam.egAmount' | translate: { amount: salary.frequency === 'hour' ? 30 : 45000 }
                "
            />

            <mat-error *ngIf="salaryRate.invalid">{{ firstName.errors | formErrors }}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label appRemoveAriaOwns>{{ 'self-serve.payYourTeam.employmentType' | translate }}</mat-label>
            <mat-select
                required
                #employmentType="ngModel"
                name="employmentType"
                placeholder="{{ 'self-serve.payYourTeam.selectAnEmploymentType' | translate }}"
                [(ngModel)]="employee.employmentType"
            >
                <mat-option *ngFor="let employmentType of employmentTypeValues" [value]="employmentType">{{
                    employmentTypeDisplay[employmentType] | translate | capitalize
                }}</mat-option>
            </mat-select>

            <mat-error *ngIf="employmentType.invalid">{{ employmentType.errors | formErrors }}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ 'self-serve.payYourTeam.hoursPerWeek' | translate }}</mat-label>
            <input
                type="number"
                [min]="0"
                [max]="168"
                placeholder="{{ 'self-serve.payYourTeam.eg40' | translate }}"
                name="hoursPerWeek"
                required
                #hoursPerWeek="ngModel"
                matInput
                [(ngModel)]="salary.hoursPerWeek"
            />

            <mat-error *ngIf="hoursPerWeek.invalid">{{ hoursPerWeek.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>

    <app-segment-header title="self-serve.payYourTeam.personalBankingInformation"></app-segment-header>

    <div class="responsive-grid">
        <mat-form-field>
            <mat-label>{{ 'self-serve.payYourTeam.institutionNumber' | translate }}</mat-label>
            <input
                required
                pattern="\d{3}"
                matInput
                type="text"
                name="institutionNumber"
                #institutionNumber="ngModel"
                [(ngModel)]="bankAccount.institutionNumber"
            />

            <mat-hint>{{ 'self-serve.payYourTeam.institutionNumberHint' | translate }}</mat-hint>
            <mat-error *ngIf="institutionNumber.invalid">{{
                'self-serve.payYourTeam.institutionNumberInvalid' | translate
            }}</mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label>{{ 'self-serve.payYourTeam.branchNumber' | translate }}</mat-label>
            <input
                required
                pattern="\d{5}"
                matInput
                type="text"
                name="branchNumber"
                #branchNumber="ngModel"
                [(ngModel)]="bankAccount.branchNumber"
            />

            <mat-hint>{{ 'self-serve.payYourTeam.branchNumberHint' | translate }}</mat-hint>
            <mat-error *ngIf="branchNumber.invalid">{{
                'self-serve.payYourTeam.branchNumberInvalid' | translate
            }}</mat-error>
        </mat-form-field>
        <mat-form-field>
            <mat-label>{{ 'self-serve.payYourTeam.accountNumber' | translate }}</mat-label>
            <input
                required
                pattern="\d{5,12}"
                matInput
                type="text"
                name="accountNumber"
                #accountNumber="ngModel"
                [(ngModel)]="bankAccount.accountNumber"
            />

            <mat-hint>{{ 'self-serve.payYourTeam.accountNumberHint' | translate }}</mat-hint>
            <mat-error *ngIf="accountNumber.invalid">{{
                'self-serve.payYourTeam.accountNumberInvalid' | translate
            }}</mat-error>
        </mat-form-field>
    </div>

    <div class="flex buttons justify-end">
        <ui-button *ngIf="showIWillDoItLater" type="outline" (click)="next()">{{
            'self-serve.iWillDoItLater' | translate
        }}</ui-button>
        <ui-button type="primary" [submit]="true" [disabled]="isSaving">{{ 'save' | translate }}</ui-button>
    </div>
</form>

<ui-dialog
    [open]="showCreateJobModal"
    [form]="positionForm"
    size="small"
    (primaryButtonPressed)="onCreatePosition(newJob)"
    primaryButtonLabel="save"
    (secondaryButtonPressed)="clearPosition()"
    (closing)="clearPosition()"
    secondaryButtonLabel="cancel"
    header="{{ 'applicant-tracker.createNewPosition' | translate }}"
>
    <form #positionForm="ngForm">
        <app-position-form *ngIf="showCreateJobModal" [position]="newJob"></app-position-form>
    </form>
</ui-dialog>

<ui-dialog *ngIf="isAvatarDialogOpen" [open]="isAvatarDialogOpen" (closing)="isAvatarDialogOpen = false" header="">
    <app-avatar-upload
        (onUpload)="handleAvatarUploadTerminated($event)"
        *ngIf="isAvatarDialogOpen"
        [employee]="employee"
    ></app-avatar-upload>
</ui-dialog>
